<div class="py-32" fxLayoutAlign="center start" class="home-results" fxFlex>
    <div fxLayout="column" fxFlex="100" fxFlex.xs="85" class="p-16">

        <h2>{{ 'Total' | translate }} {{totalResults}} {{(totalResults !== 1? 'ads' :'ad') | translate}} </h2>

        <div fxLayout="row wrap" class="cards-wrapper">
            <ads-card *ngFor="let project of projects" [data]="project" fxFlex="25" fxFlex.md="33" fxFlex.sm="48"
                fxFlex.lt-sm="100">
            </ads-card>
        </div>

    </div>
</div>